import lockManager from "../../../infrastructure/locking/lockManager";
import IdNameAndNumber from "../../../types/report/IdNameAndNumber";
import DragAndDropError from "../../../types/report/DragAndDropError";
import ComponentType from "../../../types/report/ComponentType";
import ActionType from "../../../types/report/ActionType";
import operandHelper from "../../../infrastructure/helpers/functions/operand/operandHelper";
import DragAndDropItem from "../../../types/report/DragAndDropItem";
import Operand from "../../../types/functions/Operand/Operand";
import ReportConfig from "../../../types/report/ReportConfig";

const validateAction = async (number: number,
    isInsertAfter: boolean,
    collection: IdNameAndNumber[],
    componentType: ComponentType,
    action: ActionType,
    reportConfig: ReportConfig,
    componentId?: number): Promise<string> => {

    if (number > 0) {
        const selectedIndex = collection.findIndex(v => v.number === number);
        const startIndex = isInsertAfter ? selectedIndex + 1 : selectedIndex;
        const componentsIds: number[] = [];

        const selectedItemName = collection[selectedIndex].name;

        for (var i = startIndex; i < collection.length; i++) {
            componentsIds.push(collection[i].id || 0);
        }

        const result = await lockManager.isAnyComponentLocked({ componentType, reportConfigId: reportConfig.id as number, componentsIds });
        if (result.lockedBy) {
            const id = parseInt(result.lockedBy);
            const lockedItemName = collection.find(v => v.id === id)?.name || '';
            return `Cannot ${action} ${selectedItemName} because ${componentType} ${lockedItemName} with ID: ${id} is locked.`;
        }
    }

    return '';
}

const validateDragAndDrop = (draggedItem: DragAndDropItem, dropItem: DragAndDropItem, componentType: ComponentType): DragAndDropError => {

    const error = 'Cannot drag and drop. Remove reference first.';

    let result: DragAndDropError = { error: '', isDrag: false, number: 0 };

    const smallerNumber = Math.min(dropItem.number, draggedItem.number);
    const biggerNumber = Math.max(dropItem.number, draggedItem.number);

    let bothItems = [draggedItem, dropItem];


    bothItems.forEach((item) => {

        if (item.assignment) {
            operandHelper.proceedWhitAssignment(item.assignment, (operand: Operand) => {

                setResult(componentType, operand, smallerNumber, biggerNumber, result, error, item, draggedItem);
            });
        }
        else if (item.condition) {
            operandHelper.proceedWhitCondition(item.condition, (operand: Operand) => {

                setResult(componentType, operand, smallerNumber, biggerNumber, result, error, item, draggedItem);
            });
        }
    });

    return result;
}

const reportComponentBuildersHelper = {
    validateAction,
    validateDragAndDrop
}

export default reportComponentBuildersHelper;

function setResult(componentType: ComponentType, operand: Operand, smallerNumber: number, biggerNumber: number, result: DragAndDropError, error: string, item: DragAndDropItem, draggedItem: DragAndDropItem) {
    let operandNumber;

    switch (componentType) {
        case ComponentType.Lookup: operandNumber = operand.lookupNumber; break;
        case ComponentType.Variable: operandNumber = operand.variableNumber; break;
        default: break;
    }

    if (operandNumber) {
        if (operandNumber >= smallerNumber && operandNumber <= biggerNumber) {
            result.error = error;
            result.isDrag = item.number === draggedItem.number;
            result.number = operandNumber;
        }
    }
}
